export type ServiceType = 'washOnly' | 'ironOnly' | 'washIron';

export interface PackageSubscriber {
  id: string;
  name: string;
  phone: string;
  subscribeDate: string;
  remainingItems: number;
  totalItems: number;
  expiryDate: string;
  status: 'active' | 'expired';
}

export interface LaundryPackage {
  id: string;
  name: string;
  serviceType: ServiceType;
  itemCount: number;
  validityDays: number;
  price: number;
  originalPrice: number;
  active: boolean;
  subscribers: PackageSubscriber[];
}

export const serviceTypeMeta: Record<ServiceType, { label: string; icon: string }> = {
  washOnly: { label: 'غسيل فقط', icon: 'ri-drop-line' },
  ironOnly: { label: 'كوي فقط', icon: 'ri-fire-line' },
  washIron: { label: 'غسيل وكوي', icon: 'ri-sparkling-2-line' },
};

export const packagesList: LaundryPackage[] = [
  {
    id: 'PKG-01',
    name: 'باقة الأساس',
    serviceType: 'washIron',
    itemCount: 20,
    validityDays: 30,
    price: 400,
    originalPrice: 500,
    active: true,
    subscribers: [
      { id: 'SUB-01', name: 'عبدالله الشمري', phone: '0501234567', subscribeDate: '2026-09-16', remainingItems: 20, totalItems: 20, expiryDate: '2026-10-16', status: 'active' },
      { id: 'SUB-02', name: 'غادة المالكي', phone: '0559876543', subscribeDate: '2026-09-13', remainingItems: 9, totalItems: 20, expiryDate: '2026-10-13', status: 'active' },
      { id: 'SUB-03', name: 'فهد الدوسري', phone: '0563214567', subscribeDate: '2026-09-08', remainingItems: 3, totalItems: 20, expiryDate: '2026-10-08', status: 'active' },
      { id: 'SUB-04', name: 'سارة العتيبي', phone: '0508889991', subscribeDate: '2026-08-20', remainingItems: 0, totalItems: 20, expiryDate: '2026-09-19', status: 'active' },
    ],
  },
  {
    id: 'PKG-02',
    name: 'باقة العائلة',
    serviceType: 'washIron',
    itemCount: 50,
    validityDays: 45,
    price: 850,
    originalPrice: 1100,
    active: true,
    subscribers: [
      { id: 'SUB-05', name: 'خالد الغامدي', phone: '0554445566', subscribeDate: '2026-09-15', remainingItems: 50, totalItems: 50, expiryDate: '2026-10-30', status: 'active' },
      { id: 'SUB-06', name: 'هند المطيري', phone: '0507771122', subscribeDate: '2026-09-12', remainingItems: 28, totalItems: 50, expiryDate: '2026-10-27', status: 'active' },
      { id: 'SUB-07', name: 'تركي السبيعي', phone: '0553336677', subscribeDate: '2026-08-30', remainingItems: 4, totalItems: 50, expiryDate: '2026-10-14', status: 'active' },
    ],
  },
  {
    id: 'PKG-03',
    name: 'باقة العناية المميزة',
    serviceType: 'washIron',
    itemCount: 80,
    validityDays: 60,
    price: 1250,
    originalPrice: 1700,
    active: true,
    subscribers: [
      { id: 'SUB-08', name: 'ناصر الحربي', phone: '0502228899', subscribeDate: '2026-09-15', remainingItems: 80, totalItems: 80, expiryDate: '2026-11-14', status: 'active' },
      { id: 'SUB-09', name: 'ريم الشهراني', phone: '0556669900', subscribeDate: '2026-09-05', remainingItems: 41, totalItems: 80, expiryDate: '2026-11-04', status: 'active' },
    ],
  },
  {
    id: 'PKG-04',
    name: 'باقة الغسيل الأسبوعية',
    serviceType: 'washOnly',
    itemCount: 30,
    validityDays: 30,
    price: 350,
    originalPrice: 420,
    active: true,
    subscribers: [
      { id: 'SUB-10', name: 'منى القحطاني', phone: '0551237890', subscribeDate: '2026-09-14', remainingItems: 30, totalItems: 30, expiryDate: '2026-10-14', status: 'active' },
      { id: 'SUB-11', name: 'أحمد العنزي', phone: '0509998877', subscribeDate: '2026-09-10', remainingItems: 15, totalItems: 30, expiryDate: '2026-10-10', status: 'active' },
      { id: 'SUB-12', name: 'نورة الزهراني', phone: '0564443322', subscribeDate: '2026-08-28', remainingItems: 2, totalItems: 30, expiryDate: '2026-09-27', status: 'active' },
    ],
  },
  {
    id: 'PKG-05',
    name: 'باقة الكوي الشهري',
    serviceType: 'ironOnly',
    itemCount: 40,
    validityDays: 30,
    price: 320,
    originalPrice: 380,
    active: false,
    subscribers: [
      { id: 'SUB-13', name: 'ماجد العودة', phone: '0551112233', subscribeDate: '2026-08-01', remainingItems: 0, totalItems: 40, expiryDate: '2026-08-31', status: 'expired' },
    ],
  },
];